import React from "react";
import AddSurahForm from "../../components/forms/addContentForms/AddSurahForm";

export const AddSurah = () => {
  return (
    <React.Fragment>
      <AddSurahForm />
    </React.Fragment>
  );
};